fragment MasterTemplate on MasterTemplate {
    _id
    name
    adType
    reportingLabel
    backupQuality
    height
    width
    persistentKey
    sourceDocuments
    defaultSharedOverrides
    collapsed
    preview
    created
    modified
    parentId
    measurementUnit
    sourceDocuments
    defaultSharedOverrides
    aeInfo {
        completed
        plainlyTemplateId
        plainlyProjectId
    }
}
